import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WEBINAR, formatWebinarDate } from "@/lib/content";

export const StickyCta = ({ onCtaClick, seatsRemaining, settings }) => {
  const [show, setShow] = useState(false);
  const dateLabel = formatWebinarDate(settings?.webinar_date, "short", WEBINAR.dateLabel);

  useEffect(() => {
    const onScroll = () => {
      const scrolled = window.scrollY > 700;
      // Hide near bottom (within 650px of bottom — form area)
      const nearBottom =
        window.scrollY + window.innerHeight >
        document.documentElement.scrollHeight - 650;
      setShow(scrolled && !nearBottom);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 30 }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          className="fixed bottom-20 left-3 right-3 sm:bottom-4 sm:left-4 sm:right-4 lg:hidden z-50"
        >
          <div className="rounded-full bg-[#0A0A0A]/95 backdrop-blur border border-[rgba(255,255,255,0.12)] shadow-[0_20px_60px_rgba(0,0,0,0.5)] pl-4 pr-1.5 py-1.5 flex items-center gap-3">
            <div className="min-w-0 flex-1">
              <div className="text-[10px] text-[hsl(var(--muted-foreground))] uppercase tracking-widest">
                名額剩 <span className="text-[hsl(var(--lime))] font-semibold font-num">{seatsRemaining ?? "—"}</span>
              </div>
              <div className="text-[12px] text-[hsl(var(--foreground))] font-medium truncate">
                {dateLabel} · Zoom 分享會
              </div>
            </div>
            <Button
              data-testid="webinar-cta-sticky-button"
              onClick={onCtaClick}
              className="btn-lime btn-lime-pulse h-11 px-5 text-[14px] font-bold whitespace-nowrap"
            >
              {WEBINAR.ctaCopy}
              <ArrowRight className="w-3.5 h-3.5 ml-1" />
            </Button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
